import React, { useState } from "react";

interface Employee {
  employee_id: string;
  employee_name: string;
  department: string;
}

interface Props {
  value: Employee[];
  onChange: (value: Employee[]) => void;
  placeholder?: string;
  suggestions: Employee[];
}

const CommonTagsInputWithSuggestions: React.FC<Props> = ({
  value,
  onChange,
  placeholder = "Type name / code",
  suggestions,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState<Employee[]>(
    []
  );
  const [showSuggestions, setShowSuggestions] = useState(false);
  console.log(suggestions)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setInputValue(val);

    if (val.trim()) {
      const matches = suggestions.filter(
        (item) =>
          item.employee_name.toLowerCase().includes(val.toLowerCase()) ||
          item.employee_id.toLowerCase().includes(val.toLowerCase())
      );
      setFilteredSuggestions(matches);
      setShowSuggestions(true);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelect = (employee: Employee) => {
    if (!value.find((item) => item.employee_id === employee.employee_id)) {
      onChange([...value, employee]);
    }
    setInputValue("");
    setShowSuggestions(false);
  };

  const handleRemove = (code: string) => {
    onChange(value.filter((item) => item.employee_id !== code));
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div className="tags-input-container mb-2">
        {value.map((item) => (
          <span key={item.employee_id} className="badge bg-primary me-1">
            {item.employee_name} ({item.employee_id})
            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              onClick={() => handleRemove(item.employee_id)}
              style={{ fontSize: "0.6rem", marginLeft: "8px" }}
            />
          </span>
        ))}
      </div>

      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
      />

      {showSuggestions && filteredSuggestions.length > 0 && (
        <div
          className="dropdown-menu show"
          style={{
            width: "100%",
            maxHeight: "250px",
            overflowY: "auto",
            position: "absolute",
            zIndex: 1000,
          }}
        >
          <table className="table table-bordered table-hover mb-0">
            <thead className="table-light sticky-top">
              <tr>
                <th>Emp Code</th>
                <th>Employee Name</th>
                <th>Department</th>
              </tr>
            </thead>
            <tbody>
              {filteredSuggestions.map((item) => (
                <tr
                  key={item.employee_id}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSelect(item)}
                >
                  <td>{item.employee_id}</td>
                  <td>{item.employee_name}</td>
                  <td>{item.department}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CommonTagsInputWithSuggestions;
